export default __webpack_public_path__ + "static/media/post-Icon-new.3a6c8a83.svg";